/* eslint-disable no-return-assign */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'

class InfiniteScroll extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    renderBack: false,
  }

  triggerListener = debounce(() => {
    if (!this.container) return

    this.checkPosition()

    if (this.props.preventListener) return

    if (window.scrollY + window.innerHeight > this.container.clientHeight + this.container.offsetTop - this.props.scrollTriggerHeight) {
      this.props.scrollListener()
    }
  }, 100)

  componentDidMount() {
    window.addEventListener('scroll', this.triggerListener)
    this.checkPosition()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.triggerListener)
  }

  checkPosition = () => {
    if (!this.props.backTopComponent) return

    this.setState({ renderBack: window.scrollY > window.innerHeight * 0.2 })
  }

  render() {
    const { children, backTopComponent: Back, ...rest } = this.props
    return (
      <>
        {children({ ...rest, containerRef: el => (this.container = el) })}
        {Boolean(this.state.renderBack) && <Back />}
      </>
    )
  }
}

InfiniteScroll.propTypes = {
  children: PropTypes.func,
  scrollListener: PropTypes.func.isRequired,
  backTopComponent: PropTypes.func,
  preventListener: PropTypes.bool,
  scrollTriggerHeight: PropTypes.number,
}

InfiniteScroll.defaultProps = {
  preventListener: false,
  scrollTriggerHeight: 100,
}

export default InfiniteScroll
